import * as React from "react";
const HaircutFemale1 = ({ color }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1920">
		<title>{"coiffure f 1"}</title>
		<g id="Calque_1" fill="none" data-name="Calque 1">
			<rect width={1080} height={1920} />
		</g>
		<g id="Calque_10" data-name="Calque 10">
			<path
				fill={color}
				stroke="black"
				strokeWidth="0.25"
				d="M476,213c2.42-3,7.89-2.09,12-2.09,8.57,0,22.85-6.23,27-12.46,7.28-10.93,8.31-29.08,8.31-29.08s43.62,43.62,81,41.54c10.39,0,18.7-6.23,22.85-6.23s8.31,4.15,8.31,4.15v2.08s8.31-2.08,10.39,2.08a60.58,60.58,0,0,1,4.15,18.7c-1.19,10.73-5.76,22.16-14.07,26.31,0,14.54-5.92,41.23-35,62,1,25,2,42.77,2,49,2.08,6.23,30.69,30.54,66,43l6,4.57L645.92,179.75s-18.7-66.47-85.17-66.47S482,172,479,180s-36.66,240.72-36.66,240.72S485.09,396.34,494,391c10.39-6.23,18.69-9.54,27-22,0-6.23,2-47,2-49,0-1-33-20-35-61.31-3-.69-8-3.69-12-10.69C467.19,232.58,473.82,215.69,476,213Z"
			/>
		</g>
	</svg>
);
export default HaircutFemale1;
